import React from 'react';
import AutomationContainer from '../../Containers/AutomationContainer';

const Automations = (props) => {
	return (
		<AutomationContainer />
	);
}

export default Automations;